module.exports = __webpack_public_path__ + "img/2025-09-19d_3.db458754.jpg";